// extracted by mini-css-extract-plugin
module.exports = {"selector":"localSelector_selector__1151V","button":"localSelector_button__XvFdd","active":"localSelector_active__2LvjD localSelector_button__XvFdd"};